"use client";

import { useState } from "react";
import Particles from "../magicui/particles";
import { FaGithub, FaLinkedin, FaEnvelope, FaCode } from "react-icons/fa6";
import {  FaFileAlt } from "react-icons/fa";

import { motion } from "framer-motion";

export function ParticlesDemo() {
  const [color] = useState("#8B5CF6"); // Modern purple color

  const socialLinks = [
    {
      icon: <FaEnvelope className="w-6 h-6" />,
      href: "mailto:kaartik1999@gmail.com",
      label: "Email"
    },
    {
      icon: <FaGithub className="w-6 h-6" />,
      href: "https://github.com/Kaartikgupta",
      label: "GitHub"
    },
    {
      icon: <FaLinkedin className="w-6 h-6" />,
      href: "https://www.linkedin.com/in/kaartik-gupta/",
      label: "LinkedIn"
    },
    {
      icon: <FaCode className="w-6 h-6" />,
      href: "https://leetcode.com/u/kaartik123/",
      label: "LeetCode"
    },
    {
      icon: <FaFileAlt className="w-6 h-6" />,
      href: "https://drive.google.com/file/d/1UyQl0_h9dXq210dzP5o8qMeW1220YQEU/view?usp=drive_link",
      label: " Download Resume"
    }
  ];

  return (
    <footer className="relative w-full min-h-screen bg-gradient-to-br from-gray-900 to-black mt-0">
      <div className="max-w-7xl mx-auto px-4 py-12 flex flex-col items-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-violet-400 to-indigo-300 mb-8 animate-fade-in text-center">
            Acheivements
          </h2>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">

          <AchievementCard
            title="Excellence Award"
            organization="Internal Engineering Team"
            description="Led the development of an internal tool to enable a new pipeline for assigning sales representatives to customers, significantly improving data accuracy and operational efficiency."
            tags={["Leadership", "System Design", "Process Automation"]}
          />

          <AchievementCard
            title="Compass Award"
            organization="Accessibility Initiative"
            description="Mentored and led a cross-functional team to successfully resolve all WCAG accessibility issues across the website, improving compliance and user experience."
            tags={["Mentorship", "WCAG", "Accessibility", "Frontend"]}
          />

          {/* future achievements / projects can go here */}
        </div>
        <div className="max-w-7xl mx-auto px-4 py-12 flex flex-col items-center">
          <h2 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-violet-400 to-indigo-300 mb-8 animate-fade-in text-center">
            Let's Connect
          </h2>
          <div className="flex flex-wrap justify-center gap-6 mb-12">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 px-6 py-3 bg-gray-800/50 backdrop-blur-sm rounded-xl hover:bg-gray-700/50 transition-all duration-300 hover:-translate-y-1"
              >
                {link.icon}
                <span className="text-gray-300 group-hover:text-white font-medium">
                  {link.label}
                </span>
              </a>
            ))}
          </div>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-violet-400 to-indigo-300 mb-8 animate-fade-in text-center">
            Try this Particle UI by moving the cursor on the screen!
          </h2>
      </div>

      <Particles
        className="absolute inset-0 z-0"
        quantity={200}
        ease={100}
        color={color}
        refresh
        staticity={30}
      />
    </footer>
  );
}

const AchievementCard = ({
  title,
  description,
  tags,
  icon,
  organization
}: {
  title: string;
  description: string;
  tags: string[];
  icon?: React.ReactNode;
  organization: string;
}) => (
  <motion.div
    whileHover={{ scale: 1.02 }}
    className="block bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors overflow-hidden"
  >
    {/* Header */}
    <div className="p-6 border-b border-gray-700 flex items-center gap-4">
      {icon && (
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-700 text-xl">
          {icon}
        </div>
      )}

      <div>
        <h3 className="text-xl font-semibold">{title}</h3>
        {organization && (
          <p className="text-sm text-gray-400">{organization}</p>
        )}
      </div>
    </div>

    {/* Content */}
    <div className="p-6">
      <p className="text-gray-300 mb-4 leading-relaxed">
        {description}
      </p>

      <div className="flex flex-wrap gap-2">
        {tags.map((tag, index) => (
          <span
            key={index}
            className="px-3 py-1 bg-gray-700 rounded-full text-sm"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  </motion.div>
);